import { ChangeDetectionStrategy, Component, inject, input, viewChild } from '@angular/core';

import { Select2EmptyStateDirective } from './empty-state.directive';
import { EmptyStateComponent } from '../../../../common/empty-state/empty-state.component';
import { IconName } from '../../../../common/icon/icons.type';

@Component({
  selector: 'rt-select-empty-state',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Select2EmptyStateDirective, EmptyStateComponent],
  template: `
    <ng-template rtSelectEmptyState>
      <div layout layout-full-width layout-justify-center>
        <rt-empty-state [icon]="iconName() ?? null" [title]="title()" [desc]="desc()" space>
        </rt-empty-state>
      </div>
    </ng-template>
  `,
  providers: [
    {
      provide: Select2EmptyStateDirective,
      useFactory: () => inject(EmptyStateDefaultComponent).directive(),
    },
  ],
})
export class EmptyStateDefaultComponent {
  public directive = viewChild.required(Select2EmptyStateDirective);

  public iconName = input<IconName>();
  public title = input<string>('');
  public desc = input<string>('');
}
